import { useRef } from "react";

/**
 * Frontier gate for auto-advance-on-selection in single-choice funnel steps.
 *
 * A step is on the "frontier" the first time it is reached, before it has an
 * answer. Selecting an option there should submit and advance immediately for
 * a snappier forward flow. Once the step has an answer and is later revisited
 * (the user navigated Back, so it mounts pre-filled), auto-advance is
 * suppressed: the user edits freely and moves on with the explicit Next button.
 *
 * The decision is captured once at mount and never flips afterward, so that
 * selecting on a fresh step does not immediately disable its own auto-advance
 * once the field becomes populated.
 *
 * @param hadInitialValue whether the step already had an answer at mount time
 * @returns true when selecting an option should auto-advance
 */
export function useAutoAdvanceOnSelect(hadInitialValue: boolean): boolean {
  return useRef(!hadInitialValue).current;
}
